import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenService } from '@app/auth/token.service';

@Injectable()
export class DecumulationBffAuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('/desacumulacao-bff/')) {
      const token = this.tokenService.getToken();

      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: token
          }
        });
      }
    }
    return next.handle(request);
  }
}
